import { CompetencyGoal } from 'generated/graphql';
import { StarIcon } from '@treams/treams-icons';
import styled, { DefaultTheme } from 'styled-components';

const GoalSkillScoreFeedbackIndexes = styled.div`
	display: flex;
	flex-direction: row;
	padding: 16px;
	justify-content: center;
	align-items: center;
	column-gap: 16px;
`;

function goalSkillColor(
	theme: DefaultTheme,
	state: 'achieved' | 'target' | 'done' | 'out-of-scope',
) {
	switch (state) {
		case 'done':
			return theme.colors.green;
		case 'achieved':
			return theme.colors.yellow;
		case 'out-of-scope':
			return theme.colors.lightBlueLight;
		default:
			return theme.colors.lightBlue;
	}
}

const GoalSkillScoreFeedbackIndex = styled.div<{
	$state: 'achieved' | 'target' | 'done' | 'out-of-scope';
}>`
	background-color: ${({ theme, $state }) => goalSkillColor(theme, $state)};
	width: 8px;
	height: 8px;
	margin: 0 4px;
	border-radius: 50%;
	display: block;
`;

const GoalSkillScoreTarget = styled.div<{ $state: 'done' | 'target' }>`
	display: flex;
	justify-content: center;
	align-items: center;
	svg {
		width: 24px;
		height: 24px;

		path {
			fill: ${({ theme, $state }) =>
				$state === 'done' ? theme.colors.green : theme.colors.lightBlue};
		}
	}
`;

export default function GoalSkillScoreIndex({
	goalCompetency,
}: {
	goalCompetency: CompetencyGoal;
}) {
	const scores = goalCompetency?.appraisals.map(
		({ competencyLevelIndex }) => competencyLevelIndex + 1,
	);
	const total = scores.reduce((current, score) => current + score, 0);
	const average = Math.round(total / scores.length);

	return (
		<GoalSkillScoreFeedbackIndexes>
			{goalCompetency.competency.competencyLevelSet.levels.map((_level, index) =>
				goalCompetency.competencyLevelIndex === index ? (
					<GoalSkillScoreTarget
						key="target"
						$state={goalCompetency.competencyLevelIndex === average ? 'done' : 'target'}
					>
						<StarIcon />
					</GoalSkillScoreTarget>
				) : (
					<GoalSkillScoreFeedbackIndex
						$state={
							goalCompetency.competencyLevelIndex === average
								? 'done'
								: index < average
								? 'achieved'
								: index < goalCompetency.competencyLevelIndex
								? 'target'
								: 'out-of-scope'
						}
						key={index}
					/>
				),
			)}
		</GoalSkillScoreFeedbackIndexes>
	);
}
